import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=482c207c&scoped=true"
import script from "./reviews.vue?vue&type=script&lang=js"
export * from "./reviews.vue?vue&type=script&lang=js"
import style0 from "./reviews.vue?vue&type=style&index=0&id=482c207c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c207c",
  null
  
)

export default component.exports